import { isAuthRetryableFetchError } from '@supabase/supabase-js'
import { supabase } from '../../supabase'
import AuthService, { SessionData } from '../domain/AuthService'

export default class SupabaseAuthService implements AuthService {
  async getSession(): Promise<SessionData | null> {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session) return null
    return {
      access_token: session.access_token,
      refresh_token: session.refresh_token,
      expires_at: session.expires_at ?? undefined,
    }
  }

  async getCurrentUserAuthID() {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser()
    if (error && isAuthRetryableFetchError(error)) throw error
    return user?.id ?? null
  }

  async signIn(email: string, password: string) {
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) throw error
  }

  async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({ email, password })
    if (error) throw error
    if (!data?.user) throw new Error('Failed to create user')

    return data.user.id
  }

  async signOut() {
    const { error } = await supabase.auth.signOut()
    if (error) throw error
  }

  async deleteUser(userID: string) {
    // TODO: Implement
    return
    // const { error } = await supabase.auth.admin.deleteUser(userID)
    // if (error) throw error
  }

  async resetPassword(email: string, redirectTo: string) {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    })
    if (error) throw error
  }

  async setSession(session: SessionData) {
    const { error } = await supabase.auth.setSession({
      access_token: session.access_token,
      refresh_token: session.refresh_token,
    })
    if (error) throw error
  }

  async updatePassword(password: string) {
    const { error } = await supabase.auth.updateUser({ password })
    if (error) throw error
  }
}
